// extracted by mini-css-extract-plugin
export default {"toggleContainer":"VersionToggle_toggleContainer__mzxyw","toggleButton":"VersionToggle_toggleButton__GR9H9","active":"VersionToggle_active__flwcc"};